<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="11">
              <h3>{{ ['Upload','Documento'].join(' ')}}</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="1">
              <vs-button @click="closeSidebar" icon-pack="feather" icon="icon-x" color="warning" type="line" align="right">Chiudi</vs-button>
            </vs-col>
          </vs-row>
          <vs-divider />
        </div>
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="documento">
            <vs-row>
              <vs-col class="w-full px-2 mt-3">
                <label class="text-warning">Carica Documento</label>
                <drag-drop-file v-model="file" v-validate="'required'" name="file"></drag-drop-file>
                <span class="text-danger" id="fileError"></span>
              </vs-col>
            </vs-row>
          </form>
        </div>
        <div class="vx-card__footer">
          <vs-row vs-type="flex" vs-justify="space-around">
            <vs-button @click="submitFile($event)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>

</template>

<script>
// For custom error message
import { Validator } from 'vee-validate';

// axios
import axios from 'axios'

// vue-select
import vSelect from 'vue-select'

import DragDropFile from '../commons/DragDropFile.vue'


const dict = {
  custom: {
    file: {
      required: 'Selezionare un file'
    },
  }
};

// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      file: {},
      tipo: "",
      categoria: "",

      descrizione: "",
    }
  },
  props: {
    selected: Number, // contratto ID
  },
  methods: {
    submitFile(){
      if(!this.file.name) {
        document.getElementById('fileError').innerHTML = "Selezionare un file"
        reject("select a file");
      } else {
        let url = '/contratto/documento/upload'


        let formData = new FormData();
          formData.append('file', this.file)
          formData.append('id_contratto', this.selected);
          formData.append('descrizione', 'Copia cartacea del contratto di riferimento');
          formData.append('categoria', 'Documenti legali');
          formData.append('tipo', 'Contratto');
          axios.post( process.env.VUE_APP_BACKEND_API + url,
            formData,
            {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              onUploadProgress: ( progressEvent ) => {
                this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
              }
            }
          ).then((r) => {
            this.$emit('documento-creato', 'OK')
          })
          .catch((e) => {
            console.log('FAILURE!!', e);
          });
        }
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  },

  components: {
    'v-select': vSelect,
    DragDropFile,
  },
}
</script>
